import { TFunction } from 'i18next';
import { useEffect, useRef, useState } from 'react';

const secondsToHms = (d: number) => {
  d = Number(d);
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);
  const s = Math.floor((d % 3600) % 60);

  return { h, m, s };
};

export function showRemainingTime(t: TFunction, countDown: number) {
  const { h, m, s } = secondsToHms(countDown);

  return t('common.loading.remaining', {
    ns: 'translations',
    defaultValue: 'Approximiately {{hours}}{{minutes}}{{seconds}} remaining',
    hours:
      h > 0
        ? t('common.loading.remain.hour', {
            ns: 'translations',
            defaultValue: '{{count}} hour, ',
            count: h,
          })
        : '',
    minutes:
      m > 0
        ? t('common.loading.remain.minute', {
            ns: 'translations',
            defaultValue: '{{count}} minute, ',
            count: m,
          })
        : '',
    seconds:
      s > 0
        ? t('common.loading.remain.second', {
            ns: 'translations',
            defaultValue: '{{count}} second',
            count: s,
          })
        : '',
  });
}

export function useCountdown(
  ETA: number | undefined,
  onCountedDown?: () => void,
) {
  const [countDown, setCountDown] = useState(ETA || 0);
  const countDownRef = useRef(countDown);
  countDownRef.current = countDown;
  useEffect(() => {
    let interval: NodeJS.Timer;
    if (countDownRef.current > 0) {
      interval = setInterval(() => {
        setCountDown(countDownRef.current - 1);
      }, 1000);
    } else if (ETA && ETA > 0) {
      onCountedDown && onCountedDown();
    }
    return () => clearInterval(interval);
  }, [onCountedDown, ETA]);
  return countDown;
}
